import cx from 'classnames'

import { Comment, Trash } from './components'

export function ActionIcons ({ selected, item, onClick, deleteFn, parentItem, className }) {
  return (
    <div className={cx(className)}>
      <Comment
        onClick={onClick}
        selected={selected}
        item={item}
        parentItem={parentItem}
      />
      <Trash
        disabled={!item.draft}
        onClick={deleteFn}
        type={Object.prototype.hasOwnProperty.call(item, 'dueDate') ? 'Action' : 'Issue'}
      />
    </div>
  )
}
